import Vue from 'vue'
import App from './App.vue'

// HTML Vue2Editor editor
import Vue2Editor from "vue2-editor";

// Vuesax Component Framework
import Vuesax from 'vuesax'

import 'vuesax/dist/vuesax.css' // Vuesax
import 'material-icons/iconfont/material-icons.css' //Material Icons

import { getCurrentTenant, hasPermission } from './utils'

Vue.use(Vuesax)

// axios
localStorage.setItem('baseUrl', process.env.VUE_APP_API_BASE_URL + getCurrentTenant())
import axios from "./axios.js"
Vue.prototype.$http = axios

// API Calls
import "./http/requests"

// register globally
import GlobalEvents from 'vue-global-events'
Vue.component('GlobalEvents', GlobalEvents)
import VueCountdown from '@chenfengyuan/vue-countdown';
Vue.component(VueCountdown.name, VueCountdown);
import VueEvents from 'vue-events'
Vue.use(VueEvents)

// Theme Configurations
import '../themeConfig.js'

// Auth0 Plugin
import AuthPlugin from "./plugins/auth"
Vue.use(AuthPlugin)

// Masks
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

// Money Mask
import money from 'v-money'
Vue.use(money)

// ACL
import acl from './acl/acl'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Vue Analytics
import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
    id: 'G-220RRKR6L5',
    router
});
// Vuex Store
import store from './store/store'

// i18n
import i18n from './i18n/i18n'

// Vuexy Admin Filters
import './filters/filters'

// Import websockets
import '@/websockets/client.js'

// Clipboard
Vue.use(VueClipboard)
import VueClipboard from 'vue-clipboard2'

// Tour
import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)

// VeeValidate
import VeeValidate from 'vee-validate'
import messages from 'vee-validate/dist/locale/pt_BR'
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
    if ('serviceWorker' in navigator) {
            register(`/service-worker.js?rand=0.37393133064606765`, { 
                registrationOptions: { scope: '/' },
                updated(registration) {
                    console.log('New content is available; please refresh.')
                    document.dispatchEvent(
                        new CustomEvent('AppUpdated', { detail: registration })
                    );              
                }            
        })
    }
}


// Merge the locales.
Vue.use(VeeValidate)
VeeValidate.Validator.localize('pt_BR', messages)

import _ from 'lodash'
Object.defineProperty(Vue.prototype, '$_', { value: _ })

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
        libraries: 'places'
    }
});

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'

Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Facebook
import { initFacebookSdk } from './utils/facebookConnect'
initFacebookSdk();

// Feather font icon
require('./assets/css/iconfont.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css'

Vue.config.productionTip = false

const vue = new Vue({
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
}).$mount('#app')

router.afterEach((to) => {
    const underlineFilter = getCurrentTenant().includes('_');
    if(getCurrentTenant() && underlineFilter){
        return vue.$router.push('/' + getCurrentTenant() + '/pages/tenant-invalid')
    }
    localStorage.setItem('baseUrl', process.env.VUE_APP_API_BASE_URL + getCurrentTenant())

    if (vue.$router.match(to).meta.rule === 'check') {
        if (!hasPermission(vue.$router.match(to).name)) {
            return vue.$router.push('/' + getCurrentTenant() + '/not-authorized')
        }

    }
})

import VueCrontab from '@/components/crontab/vue-crontab.esm'

Vue.use(VueCrontab)
Vue.use(Vue2Editor)

export default vue